<app-preloader *ngIf="isLoading"></app-preloader>
<div id="dealsViewMobile">
  <div class="titleWrapper">
    <h3>Propuestas</h3>
  </div>

  @if(isEditable){
    <button class="tertiary" (click)="addNewDeal()" [disabled]="!isValidForm"
    *ngIf="creationUser == null || creationUser == authService.currentUserIds || status !== 'SAVED' && validBranch === false">
    <i class="icon"></i>
    Nueva Propuesta
  </button>
  }
  <!-- -->
  <div class="noData" *ngIf="deals.length == 0">No hay información disponible</div>
  <div class="dealsList">
    <ng-container *ngIf="showRow == 1">
      <div *ngFor="let deal of deals; let i = index" class="deal">
        <app-row-deal-standard-quote-mobile
          [idQuote]="idQuote"
          [deal]="deal"
          [deals]="deals"
          [indexDeal]="i"
          (edit)="editDeal($event)"
          (duplicate)="duplicateDeal($event)"
          (delete)="openModalConfirmation($event)"
          (extendValidity)="extendDealValidity($event)"
          [extendingDealId]="extendingDealId"
          [creationUser]="creationUser"
          [model]="model"
          [isValidForm]="isValidForm"
          (isSelected)="isSelected($event)"
          [status]="status"
        ></app-row-deal-standard-quote-mobile>
      </div>
    </ng-container>
    <ng-container *ngIf="showRow == 2">
      <app-column-deal-standard-mobile
        [deals]="paginatedDeals"
        (edit)="editDeal($event)"
        (duplicate)="duplicateDeal($event)"
        (delete)="openModalConfirmation($event)"
        (extendValidity)="extendDealValidity($event)"
        [extendingDealId]="extendingDealId"
        [creationUser]="creationUser"
        (isSelected)="isSelected($event)"
        [status]="status"
        [isValidForm]="isValidForm"
      >
      </app-column-deal-standard-mobile>
      <ng-container *ngIf="deals.length > 8">
        <app-paginator
          [total]="deals.length"
          [label]="'Propuestas por página'"
          [pageSizeOptions]="[5, 8]"
          [pageSize]="pageSize"
          [pageIndex]="currentPageIndex"
          (changePage)="onPageChange($event)"
        ></app-paginator>
      </ng-container>
    </ng-container>
  </div>

  @if(isEditable){
    <button class="tertiary" (click)="addNewDeal()" [disabled]="!isValidForm"
    *ngIf="creationUser == null || creationUser == authService.currentUserIds || status !== 'SAVED' && validBranch === false">
    <i class="icon"></i>
    Nueva Propuesta
  </button>
  }
</div>
<ng-template #modalTemplate>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="cancelDeleteDeal()"
    (actionBtn2)="deleteDeal()"
  ></app-template-confirmation>
</ng-template>
<ng-template #extendValidityModalTemplate>
  <app-template-confirmation
    [title]="extendValidityModal.title"
    [subtitle]="extendValidityModal.subtitle"
    [btn1]="extendValidityModal.btn1"
    [btn2]="extendValidityModal.btn2"
    (closeModal)="cancelExtendDealValidity()"
    (actionBtn2)="confirmExtendDealValidity()"
  ></app-template-confirmation>
</ng-template>
